import { Component, input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ul-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss'],
  imports: [NgClass],
})
export class ChipComponent {
  showDot = input<boolean>();
  additionalClasses = input<Record<string, boolean>>();
}
